import React, { Component } from "react";
import "./style.less";
import { Card } from "antd";
import "./style.less";
import { formatDate, formatName } from "@/utils/format";
const clsPrefixbox = "c-invoice_detail";
class InvoiceDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className={clsPrefixbox}>
        <Card className="card" bordered={false} type="inner">
          <ul className="detailList">
            {Object.keys(this.props.record).map((key, index) => {
              if (key === "createTime") {
                this.props.record[key] = formatDate(this.props.record[key]);
              } else if (key === "key" || key === "invoiceId") {
                return null;
              } 
              return (
                <li key={index}>
                  <i>{formatName(key) + ":"}</i>
                  <span className="info">{this.props.record[key]!=="undefined" && this.props.record[key]}</span>
                </li>
              );
            })}
          </ul>
        </Card>
      </div>
    );
  }
}

export default InvoiceDetail;
